<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
      </div>

      <div class="d-flex align-items-center">
        <el-button type="primary"   class="ms-2 me-1" @click="toExport(true)">导出</el-button>
        <el-button type="primary"  class="ms-2 me-3" @click="handleExport">下载</el-button>
      </div>
    </div>
    <div class="pub-center pt-2" >
      <div class="search--box">
        <el-form-item label="年份：" class="me-3">
          <el-select v-model="params.year" style="width: 100px" clearable>
            <el-option v-for="i of YEARS" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="省份：" class="me-3" >
          <el-select v-model="params.province" style="width: 120px" clearable filterable>
            <el-option v-for="i of provinces" :key="i" :value="i" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="大学："  class="me-3">
          <el-select v-model="params.university_id" style="width: 120px" clearable filterable>
            <el-option v-for="i of schools" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="组别：" class="me-3" >
          <el-select v-model="params.level" style="width: 100px" clearable>
            <el-option v-for="i of LEVELS" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label="选题："  class="me-3">
          <el-select v-model="params.topic_id" style="width: 120px" clearable >
            <el-option v-for="i of topics" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label=""  >
          <el-input v-model="params.keyword" class="ms-3 me-1" style="min-width: 100px" placeholder="作品/姓名/手机号"/>
        </el-form-item>
        <el-button type="primary"  @click="getList(true)">搜索</el-button>
        <el-button type=""  @click="reset">重置</el-button>
      </div>
      <el-table border scrollbar-always-on   :data="list" style="width: calc(100% - 30px);height:calc(100% - 60px);position: absolute;left: 15px;top:50px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="年份"  min-width="80px" show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Year|| '-'}}
          </template>
        </el-table-column>
        <el-table-column label="省份"  min-width="150px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Province || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛学校" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.SchoolName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛组别" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.LevelName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="作品名称" min-width="300px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Name || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="选题类型"  min-width="150px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TopicName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛队名"   min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamContact || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="联系人手机号" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamPhone || "-"}}
          </template>
        </el-table-column>
<!--        <el-table-column label="作品简介" min-width="300px">-->
<!--          <template #default="scope" >-->
<!--            {{scope.row.DescriptionShort || "-"}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="关键词" min-width="300px">-->
<!--          <template #default="scope">-->
<!--            {{scope.row.Keywords || "-"}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="项目可行性报告" width="150px">-->
<!--          <template #default="scope">-->
<!--            <div class="d-flex flex-column align-items-center">-->
<!--              <a target="_blank" class="text-decoration-none link point-curser" @click="fullScreem(scope.row.FeasibilityUrl)">在线查看</a>-->
<!--              <a  class="text-decoration-none link point-curser" @click="downloadFun(scope.row.FeasibilityUrl,scope.row.Feasibility)">下载</a>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="项目汇报视频" width="150px">-->
<!--          <template #default="scope">-->
<!--            <div class="d-flex flex-column align-items-center">-->
<!--              <a target="_blank" class="text-decoration-none link point-curser" :href="scope.row.VideoUrl">在线查看</a>-->
<!--              <a  class="text-decoration-none link point-curser" @click="downloadFun(scope.row.VideoUrl,scope.row.Video)">下载</a>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="知识产权声明" width="150px">-->
<!--          <template #default="scope">-->
<!--            <div class="d-flex flex-column align-items-center">-->
<!--&lt;!&ndash;              <a target="_blank" class="text-decoration-none link" :href="scope.row.IpUrl">在线查看</a>&ndash;&gt;-->
<!--              <a target="_blank" class="text-decoration-none link point-curser" @click="fullScreem(scope.row.IpUrl)">在线查看</a>-->
<!--              <a class="text-decoration-none link point-curser" @click="downloadFun(scope.row.IpUrl,scope.row.Ip)">下载</a>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="创新性描述" min-width="300px">-->
<!--          <template #default="scope">-->
<!--            {{scope.row.InnovationShort  || "-"}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="产业应用描述" min-width="300px">-->
<!--          <template #default="scope">-->
<!--            {{scope.row.IndustryShort  || "-"}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="可取得的经济效益" min-width="300px">-->
<!--          <template #default="scope">-->
<!--            {{scope.row.BenefitsShort  || "-"}}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="提交时间" min-width="170px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.CreatedTime || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100px" fixed="right">
            <template #default="scope">
              <text style="color: red" v-if="scope.row.Status===3">初赛淘汰</text>
              <text style="color: #409eff" v-else-if="scope.row.Status===2">进入复赛</text>
              <text v-else>未设置状态</text>
            </template>
        </el-table-column>
                <el-table-column label="操作" width="100px" fixed="right">
                  <template #default="scope">
                    <el-button  size="small"   type="primary" @click="seeDetail(scope.$index, scope.row)">详情</el-button>
<!--                    <el-button  size="small"   type="primary" @click="seeDetail(scope.$index, scope.row)">下载</el-button>-->
                  </template>
                </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>

  </div>

  <!--  导出作品-->
  <el-dialog
      v-model="dialogVisibleExport"
      title="导出"
      height="300px"
      width="400px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleCloseExport">
    <div class="dialog-item1">
      <el-form-item label="选择年份：">
        <el-select v-model="exportYear" placeholder="请选择">
          <el-option v-for="(item,index) in YEARS" :key="index" :label="item.Name" :value="item.ID" />
        </el-select>
      </el-form-item>
      <el-form-item label="选择省份：">
        <el-select v-model="exportprovince" placeholder="请选择">
          <el-option v-for="(item,index) in provinces" :key="index" :label="item" :value="item" />
        </el-select>
      </el-form-item>


    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="handleExportResult()" :loading = "exportLoading">确定</el-button>
            <el-button  @click="toExport(false)" :loading = "exportLoading">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>



<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage} from "element-plus";
import {formatTime} from "@/utils/dateFun";


import {getName, LEVELS} from "@/utils/commonSetting";
import {getYears} from "@/utils/commonSetting"
import {getProvinces, getSchoolList} from "@/api/school";
import {getTopics} from "@/api/topicAdmin";
import {getWorks} from "@/api/entryAdmin";
import {downLoadWithoutBaseUrl, downLoadWithToken} from "@/utils/downloadFiles";
import { useRouter } from "vue-router";
import {exportScoreResults} from "@/api/ScoreResultAdmin";
let router = useRouter();
const YEARS = getYears()
const provinces = ref([]) // 省份列表
const schools = ref([]) // 学校列表
const topics = ref([])
const params = reactive({
  pageSize:10,
  current:1,
  keyword:null, // 关键词
  level:null, // 组别
  topic_id:null, // 选题id
  year:null, // 年份
  province:null, // 省份
  university_id:null, // 学校
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
const exportLoading = ref(false)
onMounted(()=>{
  getProvincesAll() // 获取所有的省份列表
  getSchoolAll() // 获取所有的省份列表
  getTopicList()// 获取选题类型
  getList()
})
// 导出 start
const exportYear = ref(new Date().getFullYear())
const exportprovince = ref()
const dialogVisibleExport = ref(false)
const handleCloseExport = ()=>{
  dialogVisibleExport.value = false
}
const toExport = (open)=>{
  dialogVisibleExport.value = open
}
const handleExportResult = async ()=>{
  exportLoading.value = true
  const res = await exportScoreResults({year:exportYear.value,province:exportprovince.value,status:params.status,stage:1})
  exportLoading.value = false
  if(res.err_code===0 && res.data){
    const filesName = `初赛评分结果.xlsx`
    downLoadWithoutBaseUrl(res.data,filesName)
  }else{
    ElMessage.warning(res.err_msg ||"无法下载")
  }
}

// 获取选题
const getTopicList = async ()=>{
  const res = await getTopics()
  if(res.success){
    topics.value = res.data || []
  }

}
const reset = ()=>{
  params.current = 1
  params.keyword = ""
  params.level = ""
  params.topic_id = ""
  params.year = ""
  params.province = ""
  params.university_id = ""
  getList(true)
}
// 获取省份列表
const getProvincesAll = async ()=>{
  const res = await getProvinces()
  if(res.success){
    provinces.value = res.data || []
  }
}
// 获取所有学校
const getSchoolAll = async ()=>{
  const res = await getSchoolList({pageSize:10000,current:1})
  if(res.success){
    schools.value = res.data || []
  }
}
// 列表
const maxLength = 30
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getWorks(params)
  loading.value = false
  if(res.success){
    total.value = res.total
    let data = res.data || []
    data.forEach(item=>{
      // if(item.University){
      //   item.Province = item.University.Province
      //   item.SchoolName = item.University.Name
      // }
      if(item.Level){
        item.LevelName = getName(LEVELS,item.Level)
      }
      if(item.Topic){
        item.TopicName = item.Topic.Name
      }
      // if(item.Description){
      //   const length = item.Description.length
      //   item.DescriptionShort =length>maxLength? item.Description.slice(1,maxLength)+"...":item.Description.slice(1,maxLength)
      // }
      // if(item.Innovation){
      //   const length = item.Innovation.length
      //   item.InnovationShort =length>maxLength? item.Innovation.slice(1,maxLength)+"...":item.Innovation.slice(1,maxLength)
      // }
      // if(item.Industry){
      //   const length = item.Industry.length
      //   item.IndustryShort =length>maxLength? item.Industry.slice(1,maxLength)+"...":item.Industry.slice(1,maxLength)
      // }
      // if(item.Benefits){
      //   const length = item.Benefits.length
      //   item.BenefitsShort =length>maxLength? item.Benefits.slice(1,maxLength)+"...":item.Benefits.slice(1,maxLength)
      // }
      if(item.Team){
        item.TeamName = item.Team.Name
        item.TeamContact = item.Team.Contact
        item.TeamPhone = item.Team.Phone
        item.TeamName = item.Team.Name
        if(item.Team.University){
          item.SchoolName = item.Team.University.Name
        }
      }
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}
// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}
// 详情
const seeDetail = (index,item)=>{
  const r = router.resolve({path:'/admin/entrydetail',query:{id:item.ID}})
  window.open(r.href,"_blank")
}
// 下载
const handleExport = ()=>{
  ElMessage.warning("功能暂未开放")
}


// 詳情
const fullScreem = (url)=>{
  if(!url){
    return ElMessage.warning("未获取到文件信息")
  }
  const r = router.resolve({path:'/pdfjs-4.10.38-dist/web/viewer.html',query:{file:url}})
  window.open(r.href,"_blank")
}
</script>

<style scoped lang="scss">
.search--box{
  width: 100%;
  height: 60px;
  overflow-x: scroll;
  display: flex;
  box-sizing: border-box;
  //position: absolute;


}
.search--box{
  ::v-deep .el-form-item__label{
    padding: 0 !important;
  }
}
//::v-deep .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}
///deep/  .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}
.link{
  background: transparent;
  border-color: transparent;
  color: #3f9dfd;
  height: auto;
  padding: 2px;
}
.link:hover{
  color: rgba(63,157,253,0.7);
}

</style>
